import type { FunctionComponent } from 'react';

import type { MerchantReportRiskLevel } from '@ballerine/common';

import { severityToClassName } from '@/common/constants';

type TagProps = {
  text: string;
  severity: MerchantReportRiskLevel;
};

export const Tag: FunctionComponent<TagProps> = ({ text, severity }) => {
  return (
    <span
      className={`inline-block rounded-sm border-0 px-1.5 py-0.5 text-xs font-normal ${severityToClassName[severity]}`}
    >
      {text}
    </span>
  );
};
